// extracted by mini-css-extract-plugin
export var activityContainer = "_jn-0";
export var typingIndicatorContainer = "_jn-1";
export var typingIndicatorDot = "_jn-2";
export var wave = "_jn-3";